import { useEffect, useState } from "react";

/** How long a quiet first load waits before the waking screen replaces the tiles. */
export const SLOW_LOAD_MS = 1600;

export function useSlowPending(pending: boolean, delayMs = SLOW_LOAD_MS): boolean {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!pending) {
      setSlow(false);
      return;
    }
    const timer = window.setTimeout(() => setSlow(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [pending, delayMs]);
  return pending && slow;
}

export function WakingNumbers() {
  return (
    <div className="card waking">
      <div className="empty" role="status" aria-live="polite" aria-busy="true">
        <span className="empty-mark" aria-hidden="true">
          <span className="waking-dots"><i /><i /><i /></span>
        </span>
        <h3>Fetching the latest numbers</h3>
        <div className="waking-track" aria-hidden="true"><i /></div>
      </div>
    </div>
  );
}
